module.exports = __webpack_public_path__ + "img/again_write.e5c73b90.png";